// Routes of the Secure AI Adoption site.
// "/", "/about" and "/customers" are switched in src/router/index.js (they also exist in the
// legacy site);
// every other security page is registered here and spread in before the 404 catch-all.
import SecurityHome from '@/views/security/home/SecurityHome.vue';
import SecurityAbout from '@/views/security/about/SecurityAbout.vue';
import SecurityServices from '@/views/security/services/SecurityServices.vue';
import SecurityAssessment from '@/views/security/assessment/SecurityAssessment.vue';
import SecurityScore from '@/views/security/score/SecurityScore.vue';
import SecurityRoadmap from '@/views/security/roadmap/SecurityRoadmap.vue';
import SecurityBaseline from '@/views/security/baseline/SecurityBaseline.vue';
import SecurityCustomers from '@/views/security/customers/SecurityCustomers.vue';
import { seoMeta } from '@/content/security/seo';
import { ROUTES } from '@/content/security/routes';

// Used by src/router/index.js for the switched "/" and "/about" routes.
export const securityHome = { component: SecurityHome, meta: seoMeta('home') };
export const securityAbout = { component: SecurityAbout, meta: seoMeta('about') };
// "/customers" is switched the same way; it keeps the legacy route's meta.
export const securityCustomers = { component: SecurityCustomers };

export default [
  { path: ROUTES.services, name: 'securityServices', component: SecurityServices, meta: seoMeta('services') },
  { path: ROUTES.assessment, name: 'securityAssessment', component: SecurityAssessment, meta: seoMeta('assessment') },
  { path: ROUTES.score, name: 'securityScore', component: SecurityScore, meta: seoMeta('score') },
  { path: ROUTES.roadmap, name: 'securityRoadmap', component: SecurityRoadmap, meta: seoMeta('roadmap') },
  { path: ROUTES.baseline, name: 'securityBaseline', component: SecurityBaseline, meta: seoMeta('baseline') },
];
